export default class Slideshow {
	constructor( {
		slidesContainer,
		bookmarksContainer,
		navsContainer,
		autoWidth = false,
		loop = false,
		storiesMode = false,
		autoPlay = false,
		autoPlayDuration = 5500,
		switchCallback = () => null,
		secondSwitchCallback = () => null,
	} ) {
		this._slidesContainer = slidesContainer;
		this._bookmarksContainer = bookmarksContainer;
		this._navsContainer = navsContainer;
		this._autoWidth = autoWidth;
		this._loop = loop;
		this._storiesMode = storiesMode;
		this._autoPlay = autoPlay;
		this._autoPlayDuration = autoPlayDuration;
		this._setAutoPlaySwitcher = () => {};

		this._switchCallback = switchCallback;
		this._secondSwitchCallback = secondSwitchCallback;

		this._prevBookmark = this._bookmarksContainer ? this._bookmarksContainer.querySelector(`.prev`) : null;
		this._nextBookmark = this._bookmarksContainer ? this._bookmarksContainer.querySelector(`.next`) : null;

		this._slides = Array.from(this._slidesContainer.children);
		this._navs = Array.from(this._navsContainer.children);
		this._visibleNavs = null;
		
		this._currentSlide = this._slides[0];
		this._currentNav = this._navs[0];
		
		this._currentSliderShift = 0;
		this._sliderShift = 100;
		this._navsContainerShift = this._currentNav ? this._currentNav.offsetWidth : 0;

		this._maxSlideIndex = this._getMaxSliderShiftIndex();
		
		this._bookmarksContainerClickHandler = null;
		this._navsContainerClickHandler = null;
		this._sliderStartHandler = null;
		this._sliderMoveHandler = null;
		this._sliderEndHandler = null;
		this._windowResizeHandler = null;
		
		this._isRebuild = false;

		this._wasLoop = false;
		this._wasCancelLoop = false;

		if (this._slides.length > 1)
		{
			this._init();
		}
	}

	destroy()
	{
		this._isRebuild = false;
		
		this._currentSliderShift = 0;
		
		this._slidesContainer.style.transform = ``;
		this._navsContainer.style.transform = ``;

		this._currentSlide.classList.remove(`current`);
		this._currentNav.classList.remove(`current`);
		
		if ( this._prevBookmark )
		{
			this._prevBookmark.classList.remove(`disabled`);
		}
		
		if ( this._nextBookmark )
		{
			this._nextBookmark.classList.remove(`disabled`);
		}

		this._navsContainer.classList.remove(`show`);
		
		if ( this._bookmarksContainer )
		{
			this._bookmarksContainer.classList.remove(`show`);
		}
		
		this._navsContainer.classList.remove(`custom-position`);

		if ( this._bookmarksContainer )
		{
			this._bookmarksContainer.removeEventListener( `click`, this._bookmarksContainerClickHandler);
		}
		
		this._navsContainer.removeEventListener( `click`, this._navsContainerClickHandler);

		this._slidesContainer.removeEventListener(`touchstart`, this._sliderStartHandler);
		document.removeEventListener(`touchmove`, this._sliderMoveHandler);
		document.removeEventListener(`touchend`, this._sliderEndHandler);

		this._slidesContainer.removeEventListener(`mousedown`, this._sliderStartHandler);
		document.removeEventListener(`mousemove`, this._sliderMoveHandler);
		document.removeEventListener(`mouseup`, this._sliderEndHandler);

		window.removeEventListener(`resize`, this._windowResizeHandler);
	}
	
	rebuild()
	{
		if ( !this._isRebuild )
		{
			this._isRebuild = true;
			this._init();
		}
	}
	
	_getMaxSliderShiftIndex()
	{
		const slideCount = this._slides.length;

		if ( !slideCount )
		{
			return false;
		}

		if ( this._autoWidth )
		{
			return slideCount - 1;
		}
		else
		{
			const slidesContainerWidth = this._slidesContainer.offsetWidth;
			const slideWidth = this._slides[0].offsetWidth;
			const visibleSlidesCount = Math.floor( slidesContainerWidth / slideWidth );
			return Math.ceil( slideCount / visibleSlidesCount ) - 1;
		}
	}

	_calculateSliderShift( nextItemIndex )
	{
		const minShift = 400;

		if ( nextItemIndex < this._slides.indexOf(this._currentSlide) )
		{
			const prevSlide = this._slides[ this._slides.indexOf(this._currentSlide) - 1];
			this._sliderShift = ( prevSlide.offsetWidth + parseInt( getComputedStyle( prevSlide ).marginRight ));
		}
		else
		{
			this._sliderShift = this._currentSlide.offsetWidth + parseInt( getComputedStyle( this._currentSlide ).marginRight );
		}
		if ( this._sliderShift === parseInt( getComputedStyle( this._currentSlide ).marginRight ))
		{
			this._sliderShift = minShift;
		}

		return this._sliderShift;
	}

	_calculateCurrentSliderShift()
	{
		const currentSlideIndex = this._slides.indexOf(this._currentSlide);
		let shift = 0;

		for ( let slide = 0; slide < currentSlideIndex; slide++ )
		{
			shift += ( this._slides[slide].offsetWidth + parseInt( getComputedStyle( this._slides[slide] ).marginRight ));
		}

		return shift;
	}

	_init()
	{
		this._updateVisibleNavs();
		this._setCurrentSlide( 0 );
		this._setCurrentNav( 0 );
		this._navsContainer.classList.add(`show`);
		
		if ( this._bookmarksContainer )
		{
			this._setBookmarksContainerClickHandler();
		}
		
		this._setNavsContainerClickHandler();
		this._setSlidesContainerMoveHandler();
		this._setWindowOnResize();
		
		if ( this._bookmarksContainer )
		{
			this._updateBookmarksState( 0 );
			this._bookmarksContainer.classList.add(`show`);
		}

		if ( this._autoWidth )
		{
			this._calculateSliderShift( 1 );
		}
		
		if ( this._autoPlay )
		{
			this._setAutoPlayHandler();
		}
	}

	_setElementShift( element, shift, unit = `%` )
	{
		unit = this._autoWidth ? `px` : unit;
		element.style.transform = `translate3d(${shift}${unit}, 0, 0)`;
	}
	
	_changeSlide( nextItemIndex )
	{
		if ( !this._maxSlideIndex )
		{
			this._maxSlideIndex = this._getMaxSliderShiftIndex();
		}

		if ( this._storiesMode )
		{
			this._currentSliderShift = nextItemIndex * this._calculateSliderShift( nextItemIndex );
		}
		else if ( this._autoWidth )
		{
			if ( this._slidesContainer.hasAttribute( `style` ) ) {

				this._calculateSliderShift( nextItemIndex );
				const sliderShiftParsed = parseFloat( this._sliderShift );
				let currentShift;
				
				const currentShiftCalculated = this._calculateCurrentSliderShift();

				if ( nextItemIndex < this._slides.indexOf(this._currentSlide) )
				{
					currentShift = currentShiftCalculated - sliderShiftParsed;

					if ( currentShift <= 0 )
					{
						currentShift = 0;
					}
				} 
				else if ( nextItemIndex == this._slides.indexOf(this._currentSlide) )
				{
					currentShift = currentShiftCalculated;
				}
				else
				{
					currentShift = currentShiftCalculated + sliderShiftParsed;
				}

				this._currentSliderShift = currentShift;
			}
			else
			{
				this._currentSliderShift = this._sliderShift;
			}

			this._maxSlideIndex = this._getMaxSliderShiftIndex();
		}
		else
		{
			this._currentSliderShift = nextItemIndex * this._sliderShift;
		}

		this._setElementShift( this._slidesContainer, this._currentSliderShift * -1);
		this._setCurrentSlide( nextItemIndex );
		this._changeNav( nextItemIndex );

		if ( this._bookmarksContainer )
		{
			this._updateBookmarksState( nextItemIndex );
		}

		this._wasCancelLoop = false;
		this._wasLoop = false;
		
		this._setAutoPlaySwitcher();
		this._switchCallback();
	}
	
	_setCurrentSlide( nextItemIndex )
	{
		if ( !this._currentSlide )
		{
			return;
		}
		
		this._currentSlide.classList.remove(`current`);
		this._currentSlide = this._slides[nextItemIndex];
		this._currentSlide.classList.add(`current`);
	}

	_changeNav( nextItemIndex )
	{
		this._setCurrentNav( nextItemIndex );
		this._setNavsContainerShift( nextItemIndex );
		
	}
	
	_setCurrentNav( nextItemIndex )
	{
		if ( !this._visibleNavs )
		{
			return;
		}
		
		if ( this._currentNav )
		{
			this._currentNav.classList.remove(`current`);	
		}
		
		this._currentNav = this._visibleNavs[nextItemIndex];

		if ( this._currentNav )
		{
			this._currentNav.classList.add(`current`);
		}
	}

	_setNavsContainerShift( nextItemIndex )
	{
		if ( !this._visibleNavs )
		{
			return;
		}
		
		if ( this._visibleNavs.length > 5 && nextItemIndex > 1 && nextItemIndex < this._visibleNavs.length - 2 )
		{
			this._setElementShift( this._navsContainer, this._navsContainerShift * ( nextItemIndex - 2 ) * -1, `px` );
		}
	}

	_loopBeforeChangeSlide(currentItemIndex, isNext, wasTransitionCanceled = false)
	{
		if (!this._wasLoop && this._loopIsOnLoop(currentItemIndex, isNext))
		{
			this._wasLoop = true;
			this._wasCancelLoop = false;

			const item = isNext ? this._slides.shift() : this._slides.pop();
			isNext ? this._slides.push(item) : this._slides.unshift(item);
			item.remove();

			if ( !wasTransitionCanceled )
			{
				this._slidesContainer.classList.add(`slideshow--no-transition`);
			}
			
			this._setElementShift( this._slidesContainer, isNext ? (this._currentSliderShift - this._sliderShift) * -1 : this._sliderShift * -1);
			this._slidesContainer.offsetHeight; // Trigger a reflow, flushing the CSS changes
			isNext ? this._slidesContainer.append(item) : this._slidesContainer.prepend(item);
			
			if ( !wasTransitionCanceled )
			{
				this._slidesContainer.classList.remove(`slideshow--no-transition`);
			}
		}
	}

	_loopIsOnLoop(currentItemIndex, isNext)
	{
		return this._loop && ( currentItemIndex === 0 && !isNext || currentItemIndex === this._slides.length - 1 && isNext );
	}

	_loopGetIndex(isNext)
	{
		return isNext ? this._slides.length - 1 : 0;
	}

	_loopCancelBeforeChangeSlide(isNext, wasTransitionCanceled = false)
	{
		if (!this._wasCancelLoop && this._wasLoop)
		{
			this._wasCancelLoop = true;
			this._wasLoop = false;

			const item = isNext ? this._slides.pop() : this._slides.shift();
			isNext ? this._slides.unshift(item) : this._slides.push(item);
			item.remove();

			if ( !wasTransitionCanceled )
			{
				this._slidesContainer.classList.add(`slideshow--no-transition`);
			}
			
			this._setElementShift( this._slidesContainer, isNext ? this._sliderShift * -1 : (this._currentSliderShift - this._sliderShift) * -1);
			this._slidesContainer.offsetHeight; // Trigger a reflow, flushing the CSS changes
			isNext ? this._slidesContainer.prepend(item) : this._slidesContainer.append(item);
			
			if ( !wasTransitionCanceled )
			{
				this._slidesContainer.classList.remove(`slideshow--no-transition`);
			}
		}
	}
	
	_setAutoPlayHandler()
	{
		let timerId = null;
		let activeTarget = null;
		let coords = [0, 0];
		const logId = new Date().getTime();
		
		const wrapperSelector = `.slideshow`;
		
		let wrapper = this._slidesContainer.closest( wrapperSelector );
		if ( !wrapper )
		{
			wrapper = this._slidesContainer.parentNode;
		}
		
		const isOnWrapper = () => {
			const [x, y] = coords;
			const {left, right, top, bottom} = wrapper.getBoundingClientRect();
			
			return x <= right && x >= left && y >= top && y <= bottom;
		}
		
		const setNextSlide = () => {
			const currentItemIndex = this._slides.indexOf(this._currentSlide);
			
			if ( !this._loop && currentItemIndex === this._maxSlideIndex ) {
				return;
			}
			
			const isNext = true;
			
			const nextItemIndex = this._loopIsOnLoop(currentItemIndex, isNext) ? this._loopGetIndex(isNext) : isNext ? currentItemIndex + 1 : currentItemIndex - 1;
			
			this._loopBeforeChangeSlide(currentItemIndex, isNext);
			this._changeSlide( nextItemIndex );
		};
		
		const runAutoPlay = () => {
			if ( timerId ) {
				if (
					wrapper.contains( document.activeElement )
					|| wrapper.contains( activeTarget )
					|| isOnWrapper()
				) {
					clearTimeout( timerId );
					timerId = null;
					
					setAutoPlaySwitcher();
					
					return;
				}
				
				setNextSlide();
			}
		}
		
		const setAutoPlaySwitcher = () => {
			if ( timerId ) {
				clearTimeout( timerId );
				timerId = null;
			}
			
			timerId = setTimeout( runAutoPlay, this._autoPlayDuration );
		};
		
		const setActiveTarget = ( {target} ) => {
			activeTarget = target;
		};
		
		const clearActiveTarget = () => {
			activeTarget = null;
		};
		
		document.addEventListener( `mousedown`, setActiveTarget );
		document.addEventListener( `mouseup`, clearActiveTarget );
		
		document.addEventListener( `touchstart`, setActiveTarget );
		document.addEventListener( `touchend`, clearActiveTarget );
		
		document.addEventListener( `mousemove`, ( evt ) => {
			coords = [evt.clientX, evt.clientY];
		})
		
		this._setAutoPlaySwitcher = setAutoPlaySwitcher;
		setAutoPlaySwitcher();
	};

	_setBookmarksContainerClickHandler()
	{
		this._bookmarksContainerClickHandler = ({target}) => {
			const li = target.closest(`li`);
			const isNext = li.classList.contains(`next`);
			const currentItemIndex = this._slides.indexOf(this._currentSlide);

			if ( !this._loop && (!isNext && currentItemIndex === 0
				|| isNext && currentItemIndex === this._maxSlideIndex) )
			{
				return;
			}

			const nextItemIndex = this._loopIsOnLoop(currentItemIndex, isNext) ? this._loopGetIndex(isNext) : isNext ? currentItemIndex + 1 : currentItemIndex - 1;

			this._loopBeforeChangeSlide(currentItemIndex, isNext);
			this._changeSlide( nextItemIndex );
			
		};
		
		this._bookmarksContainer.addEventListener( `click`, this._bookmarksContainerClickHandler);
	}

	_updateBookmarksState( nextItemIndex )
	{
		if (!this._loop)
		{
			nextItemIndex === 0 ? this._prevBookmark.classList.add(`disabled`) : this._prevBookmark.classList.remove(`disabled`);
			nextItemIndex === this._maxSlideIndex ? this._nextBookmark.classList.add(`disabled`) : this._nextBookmark.classList.remove(`disabled`);
		}
	}

	_setNavsContainerClickHandler()
	{
		this._navsContainerClickHandler = ({target}) => {
			const listItem = target.closest(`li`);

			if ( listItem /*&& window.innerWidth >= 956*/ )
			{
				const nextItemIndex = this._visibleNavs.indexOf(listItem);

				this._changeSlide(nextItemIndex);
			}
		};
		
		this._navsContainer.addEventListener( `click`, this._navsContainerClickHandler);
	}
	
	_updateVisibleNavs()
	{
		this._visibleNavs = this._navs.filter((nav) => window.getComputedStyle(nav,null).getPropertyValue(`display`) !== `none`);
		this._visibleNavs.length > 5 ? this._navsContainer.classList.remove(`custom-position`) : this._navsContainer.classList.add(`custom-position`);
	}

	_setSlidesContainerMoveHandler()
	{
		let wasStarted = false;
		let isDetecting = false;
		let startX;
		let moveX;
		let shiftX;
		let startY;
		let moveY;
		let currentSlideIndex;
		let currentSliderShift;
		let isNext;

		const isMouseEvent = ( type ) => /mouse/.test( type );

		this._sliderStartHandler = (startEvt) => {
			if ( wasStarted )
			{
				return;
			}

			isDetecting = true;

			if ( isMouseEvent(startEvt.type) )
			{
				startEvt.preventDefault();
			}

			startX = isMouseEvent(startEvt.type) ? startEvt.clientX : startEvt.touches[0].clientX;
			startY = isMouseEvent(startEvt.type) ? startEvt.clientY : startEvt.touches[0].clientY;

			currentSlideIndex = this._slides.indexOf(this._currentSlide);
			
			if ( this._autoWidth )
			{
				if ( this._slidesContainer.hasAttribute( `style` ) ) {
	
					currentSliderShift = this._calculateCurrentSliderShift() * -1;
				}
				else
				{
					currentSliderShift = 0;
				}
			}
			else
			{
				currentSliderShift = currentSlideIndex * this._sliderShift * -1;
			}
			this._slidesContainer.classList.add(`slideshow--grabbing`);
		};

		this._sliderMoveHandler = ( moveEvt ) => {
			if ( !wasStarted && !isDetecting )
			{
				return;
			}

			moveX = isMouseEvent(moveEvt.type) ? moveEvt.clientX : moveEvt.touches[0].clientX;
			moveY = isMouseEvent(moveEvt.type) ? moveEvt.clientY : moveEvt.touches[0].clientY;

			if ( isDetecting )
			{
				if (
					Math.abs(startX - moveX) >= Math.abs(startY - moveY)
					// && !moveEvt.target.closest(`ul.buttons`)
					// && !moveEvt.target.closest(`div.nav-wrapper`)
					// && !moveEvt.target.closest(`ul.bookmarks`)
				)
				{
					moveEvt.preventDefault();

					wasStarted = true;
				}

				isDetecting = false;
			}

			if ( wasStarted )
			{
				moveEvt.preventDefault();

				if ( this._autoWidth )
				{
					shiftX = (moveX - startX) + currentSliderShift;
				}
				else
				{
					shiftX = (moveX - startX) * 100 / this._slidesContainer.offsetWidth + currentSliderShift;
				}

				this._slidesContainer.classList.add(`slideshow--no-transition`);

				isNext = shiftX < currentSliderShift;

				this._loopBeforeChangeSlide( currentSlideIndex, shiftX < currentSliderShift, true );

				if (this._loopIsOnLoop(currentSlideIndex, shiftX < currentSliderShift))
				{
					shiftX += shiftX < currentSliderShift ? 100 : -100;
				} else
				{
					this._loopCancelBeforeChangeSlide( currentSlideIndex, shiftX < currentSliderShift, true );
				}
				
				this._setElementShift( this._slidesContainer, shiftX );
			}
		};

		this._sliderEndHandler = (endEvt) => {
			this._slidesContainer.classList.remove(`slideshow--grabbing`);

			if ( !wasStarted || isDetecting )
			{
				return isDetecting = false;
			}

			endEvt.preventDefault();

			let nextItemIndex;
			
			nextItemIndex = this._loopIsOnLoop(currentSlideIndex, isNext) ? this._loopGetIndex(isNext) : shiftX >= 0 ? 0 : currentSlideIndex === this._maxSlideIndex && currentSliderShift > shiftX ? currentSlideIndex : currentSliderShift > shiftX ? currentSlideIndex + 1 : currentSlideIndex - 1;

			this._slidesContainer.classList.remove(`slideshow--no-transition`);

			this._changeSlide( nextItemIndex );

			wasStarted = false;

			if ( isMouseEvent(endEvt.type) )
			{
				this._slidesContainer.addEventListener(`click`, (evt) => evt.preventDefault(), {once: true});
			}
		};

		if ( !this._storiesMode )
		{
			this._slidesContainer.addEventListener(`touchstart`, this._sliderStartHandler, {passive: true});
			document.addEventListener(`touchmove`, this._sliderMoveHandler, {passive: false});
			document.addEventListener(`touchend`, this._sliderEndHandler, {passive: false});
			
			this._slidesContainer.addEventListener(`mousedown`, this._sliderStartHandler);
			document.addEventListener(`mousemove`, this._sliderMoveHandler);
			document.addEventListener(`mouseup`, this._sliderEndHandler);
		}
	}
	
	_setWindowOnResize()
	{
		this._windowResizeHandler = () => {
			this._maxSlideIndex = this._getMaxSliderShiftIndex();
			this._updateVisibleNavs();

			if ( this._currentSliderShift / this._sliderShift > this._maxSlideIndex )
			{
				this._changeSlide( this._maxSlideIndex );
			}
		};
		
		window.addEventListener(`resize`, this._windowResizeHandler);
	}
}
